import api from "src/spintr/SpintrApi";

import {
    FETCH_ACTIVE_USER_BASE,
    UPDATE_ACTIVE_USER,
    IFetchActiveUserBaseAction,
    IUpdateActiveUserAction,
} from "./action-types"
import { IActiveUserProfile } from "./reducer";

export const getActiveUser = (): IFetchActiveUserBaseAction => ({
    payload: api.get("/api/v1/profile/me"),
    type: FETCH_ACTIVE_USER_BASE,
});

export const updateActiveUser = (user: IActiveUserProfile): IUpdateActiveUserAction => ({
    meta: {
        user
    },
    type: UPDATE_ACTIVE_USER
});

export const ProfileActions = {
    getActiveuser: getActiveUser,
};

export default ProfileActions;